import { render } from "./air_dust.vue?vue&type=template&id=0f93bd9c&scoped=true"
import script from "./air_dust.vue?vue&type=script&lang=js"
export * from "./air_dust.vue?vue&type=script&lang=js"

import "./air_dust.vue?vue&type=style&index=0&id=0f93bd9c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f93bd9c"]])

export default __exports__